import { useEffect, useState } from "react";
import { Calendar, MapPin } from "lucide-react";
import { api } from "@/lib/api";
import { mediaUrl } from "@/lib/media";
import { Section } from "@/components/Section";

export default function Events() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/events").then((r) => setItems(r.data)).catch(() => {}); }, []);

  const fmt = (d) => {
    if (!d) return "";
    try {
      const dt = new Date(d);
      return dt.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
    } catch { return d; }
  };

  return (
    <>
      <section className="bg-[#1A1A1A] text-white py-20 noise-overlay">
        <Section>
          <div className="label-eyebrow mb-4">Events</div>
          <h1 className="heading-xl text-4xl sm:text-5xl lg:text-6xl">UPCOMING <span className="text-[#E65C00]">EVENTS</span></h1>
          <p className="mt-4 text-gray-400 max-w-xl">Expos, product launches and finance camps. Come meet the team.</p>
        </Section>
      </section>

      <Section className="py-16 space-y-6">
        {items.length === 0 && <div className="text-center py-20 border border-dashed border-gray-300 text-gray-500">No events scheduled.</div>}
        {items.map((e) => (
          <article key={e.id} className="grid md:grid-cols-[280px_1fr] border border-gray-200 hover:border-[#1A1A1A] transition-colors" data-testid={`event-card-${e.id}`}>
            <div className="aspect-[16/10] md:aspect-auto bg-gray-100">
              <img src={mediaUrl(e.cover_image)} alt={e.title} className="w-full h-full object-cover" />
            </div>
            <div className="p-6">
              <div className="flex flex-wrap gap-4 text-xs text-gray-500 uppercase tracking-widest">
                <span className="flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5 text-[#E65C00]" /> {fmt(e.event_date)}</span>
                {e.location && <span className="flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5 text-[#E65C00]" /> {e.location}</span>}
              </div>
              <h3 className="heading-xl text-2xl mt-3">{e.title}</h3>
              <p className="text-gray-700 mt-3 leading-relaxed">{e.description}</p>
            </div>
          </article>
        ))}
      </Section>
    </>
  );
}
